import { privateApi } from 'services';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';
import { CreateTalentList, TalentList, UpdateTalentList } from './types';

const createTalentList = (businessAccountId: string, talentList: CreateTalentList): Promise<void> =>
    privateApi.post<void>(`business-accounts/${businessAccountId}/leads/talent-lists`, talentList, {}, true);

const archive = (talentListId: string): Promise<void> =>
    privateApi.post<void>(`talent-lists/${talentListId}/archive`, undefined, {}, true);

const unarchive = (talentListId: string): Promise<void> =>
    privateApi.post<void>(`talent-lists/${talentListId}/unarchive`, undefined, {}, true);

const updateTalentList = (talentListId: string, talentList: UpdateTalentList): Promise<void> =>
    privateApi.put<void>(`talent-lists/${talentListId}`, talentList);

export const TalentListGateway = {
    createTalentList,
    archive,
    unarchive,
    updateTalentList,
};

const cancelableFetchTalentLists = (businessAccountId: string): Promise<TalentList[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<TalentList[]>(
        `business-accounts/${businessAccountId}/leads/talent-lists`,
    );

const cancelableFetchTalentList = (talentListId: string): Promise<TalentList> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<TalentList>(`talent-lists/${talentListId}`);

export const CancelableTalentListGateway = {
    cancelableFetchTalentLists,
    cancelableFetchTalentList,
};
